<script>
  import AgoraRTC from "agora-rtc-sdk-ng";
  import UserAvatar from "./UserAvatar.svelte";
  import { supabase } from "../auth";
  import { onMount, onDestroy } from "svelte";

  export let channel;
  let container;
  let connectedUsers = [];
  let baseUrl = __tactical_view.env.AGORA_TOKEN_SERVER_URL;
  let uid = supabase.auth.user().id;
  let level = 0;

  let rtc = {
    client: null,
    localAudioTrack: null,
  };

  let options = {
    appId: __tactical_view.env.AGORA_APP_ID,
    channel: channel,
    token: null,
  };

  rtc.client = AgoraRTC.createClient({
    mode: "rtc",
    codec: "vp8",
  });

  async function fetchUser(uid) {
    const { body } = await supabase
      .from("users")
      .select("*")
      .eq("id", uid)
      .limit(1)
      .single();
    return await body;
  }

  function addConnectedUser(userId) {
    supabase
      .from("users")
      .select("*")
      .eq("id", userId)
      .limit(1)
      .single()
      .then(({ body }) => addToConnectedUserList(body));
  }

  function addToConnectedUserList(user) {
    connectedUsers = [
      ...connectedUsers,
      { uid: user.id, level: 0, avatar_url: user.avatar_url },
    ];
  }

  onMount(async () => {
    fetch(`${baseUrl}?channel=${channel}&uid=${uid}`)
      .then((response) => response.json())
      .then((data) => {
        options.token = data.token;
        rtc.client.join(options.appId, channel, options.token, uid);
      });

    rtc.localAudioTrack = await AgoraRTC.createMicrophoneAudioTrack();
    await rtc.client.publish([rtc.localAudioTrack]);

    rtc.client.enableAudioVolumeIndicator();
  });

  onDestroy(async () => {
    rtc.localAudioTrack.close();
    await rtc.client.leave();
  });

  rtc.client.on("user-published", async (user, mediaType) => {
    addConnectedUser(user.uid);
    await rtc.client.subscribe(user, mediaType);
    if (mediaType === "audio") {
      const remoteAudioTrack = user.audioTrack;
      remoteAudioTrack.play();
    }
  });

  rtc.client.on("user-unpublished", (user) => {
    connectedUsers = connectedUsers.filter((el) => el.uid !== user.uid);
  });

  rtc.client.on("volume-indicator", (volumes) => {
    connectedUsers = connectedUsers.map((user) => {
      let volume = volumes.find((volume) => volume.uid === user.uid);
      if (volume)
        return {
          uid: user.uid,
          level: volume.level,
          avatar_url: user.avatar_url,
        };

      return user;
    });
  });

  setInterval(() => {
    level = rtc.localAudioTrack.getVolumeLevel();
  }, 100);
</script>

<div class="m-4">
  <div class="p-10 my-4 bg-gray-50 bg-opacity-90 rounded-3xl">
    <h4 class="text-center">{supabase.auth.user().email}</h4>
    <div id="me">
      {#await fetchUser(uid) then data}
        <div
          class="flex items-center justify-center my-4 mx-auto rounded-full bg-gradient-to-r w-28 h-28 {level >
          0.02
            ? 'from-green-500 to-blue-500'
            : 'from-fcred to-white'}"
        >
          <UserAvatar userAvatarUrl={data.avatar_url} />
        </div>
      {/await}
    </div>
  </div>
  <div class="p-10 my-4 bg-gray-50 bg-opacity-90 rounded-3xl">
    <h4 class="text-center">Verbundene Nutzer</h4>
    <div class="flex flex-row flex-wrap justify-center">
      {#each connectedUsers as user}
        <div
          class="flex items-center justify-center m-4 rounded-full bg-gradient-to-r w-28 h-28 {user.level >
          2
            ? 'from-green-500 to-blue-500'
            : 'from-fcred to-white'}"
        >
          <UserAvatar userAvatarUrl={user.avatar_url} />
        </div>
      {/each}
    </div>
    <div class="h-32 w-72" bind:this={container} />
  </div>
</div>
